module.exports = __webpack_public_path__ + "images/external_images/svg/business-icons/iStar_Design_Business_LineIcons_Live-73.svg";